import {ObserverData} from "@share/web-conferences/interfaces/signalr/ObserverData";
import {SignalRMethod} from "@api/repositories/reatime-repository/types";
import {SignalRObserver} from "@share/web-conferences/interfaces/signalr/SignalRObserver";

export abstract class ObserverBase implements SignalRObserver {
    method: SignalRMethod;

    constructor(protected readonly data: ObserverData) {}

    callback(data: any): Promise<void> {
        return Promise.resolve(undefined);
    }

    processConnect(connectResult: any): Promise<void> {
        return Promise.resolve(undefined);
    }
}
